
import { Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class ActivityPanel extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Notifications", "Chat", "Support", "Help"];
    }
}

export function ActivityPanel_$reflection() {
    return union_type("ActivityBar.Types.ActivityPanel", [], ActivityPanel, () => [[], [], [], []]);
}

export class SupportWidgetState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotLoaded", "Loading", "Loaded", "Hidden", "Failed"];
    }
}

export function SupportWidgetState_$reflection() {
    return union_type("ActivityBar.Types.SupportWidgetState", [], SupportWidgetState, () => [[], [], [], [], []]);
}

export function isOverlayLayout() {
    return window.innerWidth < 1280;
}

